import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class ElearningCourseStore extends LocalModel {
    constructor() {
        super('elearningCourse', {
            namePlural: 'elearningCourses',
            namePluralReal: 'elearningcourses',
            sort: 'sortOrder',
            limit: 200,
            api: {
                search: {
                    url: '/api/elearningcourses/',
                    params: {
                        limit: 200,
                        sort: 'sortOrder',
                    },
                },
                load: {
                    url: '/api/elearningcourses/',
                    params: {},
                },
                save: {
                    url: '/api/elearningcourses/admin/',
                    params: {},
                },
                delete: {
                    url: '/api/elearningcourses/admin/',
                    params: {},
                },
            },
        });
    }

    @observable newElearningCourse = {};

    @observable elearningCourse = {};

    @observable elearningCourses = [];

    /** Exams an admin may link to a course (same list the physical course uses). */
    @observable examOptions = [];

    /** [{ id, name }] for the `customers` arrayObject picker (lookupArray: 'adminCustomers'). */
    @observable adminCustomers = [];

    @action
    async loadExamOptions() {
        const response = await util.fetchApi('/api/exams/', { method: 'GET' }, { limit: 200, sort: '-createdDate' });
        if (response?.status === 200) {
            this.updateKeyValue('examOptions', (response.data || []).map(e => ({ id: e.id, title: e.title, isActive: e.isActive })));
        }
        return response;
    }

    @action
    async loadAdminCustomers() {
        const response = await util.fetchApi('/api/customers/admin/', { method: 'GET' }, { limit: 500, sort: 'name' });
        if (response?.status === 200) {
            this.updateKeyValue('adminCustomers', (response.data || []).map(c => ({ id: c.id, name: c.name })));
        }
        return response;
    }

    /**
     * Courses visible on this domain with the caller's progress row embedded.
     * @param {string} hostname - defaults to window.location.hostname
     */
    @action
    async loadWithProgress(hostname) {
        const host = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
        const response = await util.fetchApi('/api/elearningcourses/', { method: 'GET' }, { hostname: host, withProgress: 1 });
        if (response?.status === 200) {
            this.updateKeyValue('elearningCourses', response.data || []);
        }
        return response;
    }

    /**
     * Admin: one course regardless of domain/active state (all=1 → adminCourseQuery).
     * The domain-scoped loadCourse 404s on a fresh (inactive, no customers) course.
     */
    @action
    async adminLoadCourse(id) {
        const response = await util.fetchApi(`/api/elearningcourses/${id}`, { method: 'GET' }, { all: 1 });
        if (response?.status === 200) {
            this.updateKeyValue('elearningCourse', (response.data || [])[0] || {});
        } else {
            this.updateKeyValue('elearningCourse', {});
        }
        return response;
    }

    /**
     * One course with lessons (answers stripped) and the caller's progress.
     */
    @action
    async loadCourse(id, hostname) {
        const host = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
        const response = await util.fetchApi(`/api/elearningcourses/${id}`, { method: 'GET' }, { hostname: host });
        if (response?.status === 200) {
            this.updateKeyValue('elearningCourse', (response.data || [])[0] || {});
        } else {
            this.updateKeyValue('elearningCourse', {});
        }
        return response;
    }
}

const store = new ElearningCourseStore();
export default store;
